import { render, staticRenderFns } from "./SrAgreementForm.vue?vue&type=template&id=5126f988&"
import script from "./SrAgreementForm.vue?vue&type=script&lang=js&"
export * from "./SrAgreementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports